import type { FC, MouseEventHandler, ReactNode } from 'react';

import { ButtonKinds } from 'types/button';
import { twMergeClsx } from 'utils/tw-with-clsx';
import { DynamicTagButton } from 'views/shared/dynamic-tag-button';
import { SpinnerIcon } from 'views/shared/spinner-icon';

interface ButtonProps {
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  href?: string;
  kind?: ButtonKinds;
}

const buttonStyles =
  'w-full text-center h-[46px] md:h-[52px] rounded-xsmall px-4 py-2 text-base md:text-xl leading-5 md:leading-[30px] font-medium transition-colors text-white disabled:bg-fonbet-blue-100/50';
const buttonPrimaryStyles = 'active:bg-fonbet-blue-200 hover:bg-fonbet-blue-200 bg-fonbet-blue-100';
const buttonSecondaryStyles =
  'bg-white border border-solid border-fonbet-blue-100/30 hover:border-fonbet-blue-100/60 active:border-fonbet-blue-100 text-fonbet-blue-100';

const Button: FC<ButtonProps> = ({
  children,
  onClick,
  className,
  isLoading,
  href,
  kind = ButtonKinds.primary,
  disabled,
}) => {
  const classes = twMergeClsx(
    buttonStyles,
    kind === ButtonKinds.primary && buttonPrimaryStyles,
    kind === ButtonKinds.secondary && buttonSecondaryStyles,
    className,
  );

  return (
    <DynamicTagButton
      href={href}
      disabled={disabled || isLoading}
      className={classes}
      onClick={onClick}
    >
      {isLoading ? <SpinnerIcon /> : children}
    </DynamicTagButton>
  );
};

export { Button };
